import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';

class RequestServiceModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'work-order-generate-service-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#work-order-generate-service-modal {
          --modal-min-width: 55%;
          --modal-min-height: auto;
        }
        h4 {
          margin: 0;
        }
      </style>
      <h3 slot="title">Create Service Request</h3>
      <generate-service-request-action
        .href="${this.href}"
        @response="${this._onResponse}"
      >
        <span slot="header"></span>
      </bn-action>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));

    setTimeout(() => {
      this.close();
    }, 2000);
  }
}

window.customElements.define('request-service-modal', RequestServiceModal);
